import {IClothItem} from "../../../../types/index";
import {ReactComponent as VerticalMenu} from '../../../../assets/icons/menu-vertical.svg';
import {ReactComponent as DeleteIcon} from '../../../../assets/icons/trash.svg';
import {ReactComponent as ArchiveIcon} from '../../../../assets/icons/hide-icon.svg';
import {ReactComponent as RestoreIcon} from '../../../../assets/icons/restore-icon.svg';
import EmptyCloth from '../../../../assets/icons/secondSlayEmpty.svg';
import s from './clothesItemList.module.css';
import {Button, Modal} from "react-bootstrap";
import {Link} from "react-router-dom";
import React, {useEffect, useRef, useState} from "react";

interface IClothesItemProps {
    cloth: IClothItem,
    deleteAction: any,
    archiveAction: any;
    isArchive: any;
    activeTab?: string;
    deleteMissingAction?: any;
}

export function ClothesItemList(
    {cloth, deleteAction, archiveAction, isArchive, activeTab, deleteMissingAction}: IClothesItemProps
) {
    const [requiredDeletionWindow, setRequiredDeletionWindow] = useState(false);
    const [requiredArchiveWindow, setRequiredArchiveWindow] = useState(false);
    const [isMenuForButtonWindow, setIsMenuForButtonWindow] = useState(false);
    const menuRef = useRef<HTMLDivElement>(null);

    const toggleMenu = (e: React.MouseEvent) => {
        e.stopPropagation();
        setIsMenuForButtonWindow(!isMenuForButtonWindow);
    };

    useEffect(() => {
        function handleClickOutside(event: MouseEvent) {
            if (menuRef.current && !menuRef.current.contains(event.target as Node)) {
                setIsMenuForButtonWindow(false);
            }
        }

        document.addEventListener("mousedown", handleClickOutside);
        return () => {
            document.removeEventListener("mousedown", handleClickOutside);
        };
    }, []);

    const firstPhoto = cloth.photoLinks?.[0];
    const previewSrc = firstPhoto?.objectStorageThumbnail ? firstPhoto.thumbnail : firstPhoto?.original;
    return (
        <>
            <div className={s.stringTable}>
                <Link to={`/details/${cloth.id}`}
                      className={s.aStyle}
                      target={"_blank"}
                      style={{textDecoration: 'none'}}>
                    <div>{cloth.id}</div>
                    <div>
                        {previewSrc ?
                            <img className={s.photoBlock} src={previewSrc} alt={cloth.name}/> :
                            <img className={s.emptyPhotoBlock} src={EmptyCloth} alt="Нет изображения"/>}
                    </div>
                    <div>{cloth.name}</div>
                    <div>{cloth.manufacturer}</div>
                    <div>{cloth.colorCloth}</div>
                    <div>{cloth.vendorCode}</div>
                    <div>{cloth.cost} ₽</div>
                </Link>
                <div className={s.buttonsArea} ref={menuRef}>
                    <Button variant="link" onClick={toggleMenu} className={s.menuButton}>
                        <VerticalMenu className={s.editIcon}/>
                    </Button>

                    {isMenuForButtonWindow && (
                        <div className={s.menuDropdown}>
                            {activeTab != "missing" && !deleteMissingAction && (
                                <Button variant="link" onClick={() => {
                                    setIsMenuForButtonWindow(false);
                                    setRequiredDeletionWindow(true);
                                }}>
                                    <DeleteIcon className={s.managementIcon}/> Удалить
                                </Button>
                            )}

                            {activeTab === "missing" && deleteMissingAction && (
                                <Button variant="link" onClick={() => {
                                    setIsMenuForButtonWindow(false);
                                    deleteMissingAction(cloth.id);
                                }}>
                                    Оставить
                                </Button>
                            )}

                            {isArchive ? (
                                <Button variant="link" onClick={() => {
                                    setIsMenuForButtonWindow(false);
                                    setRequiredArchiveWindow(true);
                                }}>
                                    <RestoreIcon className={s.archiveIcon}/> Вернуть из архива
                                </Button>
                            ) : (
                                <Button variant="link" onClick={() => {
                                    setIsMenuForButtonWindow(false);
                                    setRequiredArchiveWindow(true);
                                }}>
                                    <ArchiveIcon className={s.archiveIcon}/> В архив
                                </Button>
                            )}
                        </div>
                    )}
                </div>
            </div>

            <Modal show={requiredDeletionWindow}
                   onHide={() => setRequiredDeletionWindow(false)}
                   backdrop="static">
                <Modal.Header closeButton>
                    <Modal.Title>Вы уверены, что хотите удалить элемент?</Modal.Title>
                </Modal.Header>
                <Modal.Footer>
                    <div className="modal-buttons">
                        <Button onClick={() => setRequiredDeletionWindow(false)} variant="Empty">Отмена</Button>
                        <Button onClick={() => {
                            deleteAction(cloth.id);
                            setRequiredDeletionWindow(false);
                        }}>Удалить</Button>
                    </div>
                </Modal.Footer>
            </Modal>

            <Modal show={requiredArchiveWindow}
                   onHide={() => setRequiredArchiveWindow(false)}
                   backdrop="static">
                <Modal.Header closeButton>
                    <Modal.Title>
                        {!isArchive ?
                            "Вы уверены, что хотите перенести элемент в архив?" :
                            "Вы уверены, что хотите вернуть элемент из архива?"}
                    </Modal.Title>
                </Modal.Header>
                <Modal.Footer>
                    <div className="modal-buttons">
                        <Button onClick={() => setRequiredArchiveWindow(false)} variant="Empty">Отмена</Button>
                        <Button onClick={() => {
                            archiveAction(cloth.id);
                            setRequiredArchiveWindow(false);
                        }}>
                            {!isArchive ? "Перенести в архив" : "Вернуть из архива"}
                        </Button>
                    </div>
                </Modal.Footer>
            </Modal>
        </>
    );
}